import type { JSX, ReactNode } from 'react';
import { Empty, Skeleton } from 'antd';

import { pctTone } from './analytics-utils';

/** Цвет тона доли (переменные — тёмная тема). */
export const TONE_COLOR = {
  green: 'var(--fk-success)',
  orange: 'var(--fk-orange)',
  red: 'var(--fk-error)',
  muted: 'var(--fk-text-muted)',
} as const;

/** Полоска с процентом справа; цвет — по порогам 75/60 или явный. */
export function PctBar({ value, color, width }: { value: number | null | undefined; color?: string; width?: number }): JSX.Element {
  const c = color ?? TONE_COLOR[pctTone(value)];
  return (
    <span className="fk-adm-bar" style={width ? { width } : undefined}>
      <span className="fk-adm-bar-track">
        <span className="fk-adm-bar-fill" style={{ display: 'block', width: `${Math.max(0, Math.min(100, value ?? 0))}%`, background: c }} />
      </span>
      <span className="fk-adm-bar-val">{value == null ? '—' : `${Math.round(value)}%`}</span>
    </span>
  );
}

/** Загрузка / пусто / содержимое — один паттерн на всех карточках вкладок. */
export function Loadable({ loading, empty, emptyText, rows = 4, children }: { loading: boolean; empty: boolean; emptyText: string; rows?: number; children: ReactNode }): JSX.Element {
  if (loading) return <Skeleton active paragraph={{ rows }} />;
  if (empty) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />;
  return <>{children}</>;
}
